import { API_ENDPOINTS } from '../../config/api.js';
import { makeApiRequest } from '../apiClient.js';

const normalizeCompanyId = (companyId) => Number(companyId || 0);

const buildSeedEndpoint = (endpoint, companyId) =>
  `${endpoint}?companyId=${encodeURIComponent(companyId)}`;

export const dataSeedingService = {
  startDbSeed: async (companyId) => {
    try {
      const normalizedCompanyId = normalizeCompanyId(companyId);
      if (!normalizedCompanyId) {
        throw new Error('Company ID is required to start DB seed.');
      }

      const response = await makeApiRequest({
        endpoint: buildSeedEndpoint(API_ENDPOINTS.START_DB_SEED, normalizedCompanyId),
        method: 'POST',
        accessToken: localStorage.getItem('accessToken'),
      });
      return response.data;
    } catch (error) {
      console.error('Start DB seed error:', error);
      throw error;
    }
  },
  startPdfSeed: async (companyId) => {
    try {
      const normalizedCompanyId = normalizeCompanyId(companyId);
      if (!normalizedCompanyId) {
        throw new Error('Company ID is required to start PDF seed.');
      }

      const response = await makeApiRequest({
        endpoint: buildSeedEndpoint(API_ENDPOINTS.START_PDF_SEED, normalizedCompanyId),
        method: 'POST',
        accessToken: localStorage.getItem('accessToken'),
      });
      return response.data;
    } catch (error) {
      console.error('Start PDF seed error:', error);
      throw error;
    }
  },
  startMediaSeed: async (companyId) => {
    try {
      const normalizedCompanyId = normalizeCompanyId(companyId);
      if (!normalizedCompanyId) {
        throw new Error('Company ID is required to start media seed.');
      }

      const response = await makeApiRequest({
        endpoint: buildSeedEndpoint(API_ENDPOINTS.START_MEDIA_SEED, normalizedCompanyId),
        method: 'POST',
        accessToken: localStorage.getItem('accessToken'),
      });
      return response.data;
    } catch (error) {
      console.error('Start media seed error:', error);
      throw error;
    }
  },
};
